import { Movie } from "../../fetcher/src/types";
import { SortOrder } from "../types";

export const searchBehavior = ({
  movieList,
  queryString,
  sortOrder,
  onlyFavorites,
  onlyUnseen,
  favorites,
  seen,
}: {
  queryString: string;
  onlyFavorites: boolean;
  favorites: string[];
  seen: string[];
  onlyUnseen: boolean;
  sortOrder: keyof typeof SortOrder;
  movieList: { data: Movie[] };
}) => {
  const nullsRemoved = movieList.data.filter((entry) => entry !== null);

  const unSeenAndFavoriteFilters = nullsRemoved.filter((entry) => {
    if (onlyFavorites) {
      if (!favorites.includes(`${entry.title}/${entry.release.date}`)) {
        return false;
      }
    }

    if (onlyUnseen) {
      if (seen.includes(`${entry.title}/${entry.release.date}`)) {
        return false;
      }
    }

    return true;
  });

  const filteredSearch = unSeenAndFavoriteFilters.filter((entry) => {
    if (queryString === "") {
      return true;
    }

    // this is getting really gross but i'm tired
    const conditions = queryString.toLowerCase().split(" and ");
    if (conditions.length == 1 && !queryString.includes(":")) {
      return (
        entry.title.toLowerCase().includes(conditions[0]) ||
        entry.description.toLowerCase().includes(conditions[0])
      );
    }

    for (let i = 0; i < conditions.length; i++) {
      const conditionPieces = conditions[i].split(":");
      const prefix = conditionPieces[0].trim();
      if (prefix === "genre") {
        return entry.genres.find((genreValue) => {
          return genreValue.toLowerCase().includes(conditionPieces[1].trim());
        });
      }
    }
  });

  return filteredSearch.sort(getComparisonFunction(sortOrder));
};

const getComparisonFunction = (sortingRule: keyof typeof SortOrder) => {
  switch (sortingRule) {
    case "Alphabetical_A_to_Z": {
      return (movieA: Movie, movieB: Movie) => {
        return movieA.title.toLowerCase() > movieB.title.toLowerCase() ? 1 : -1;
      };
    }
    case "Alphabetical_Z_to_A": {
      return (movieA: Movie, movieB: Movie) => {
        return movieA.title.toLowerCase() > movieB.title.toLowerCase() ? -1 : 1;
      };
    }
    case "MetascoreLowToHigh": {
      return (movieA: Movie, movieB: Movie) => {
        const ratingA = movieA.imdbAPIRating.metascore || 0;
        const ratingB = movieB.imdbAPIRating.metascore || 0;
        return ratingA - ratingB;
      };
    }
    case "MetascoreHighToLow": {
      return (movieA: Movie, movieB: Movie) => {
        const ratingA = movieA.imdbAPIRating.metascore || 0;
        const ratingB = movieB.imdbAPIRating.metascore || 0;
        return ratingB - ratingA;
      };
    }
    case "IMDBScoreHighToLow": {
      return (movieA: Movie, movieB: Movie) => {
        const ratingA = movieA.imdbAPIRating.imdbRating || 0;
        const ratingB = movieB.imdbAPIRating.imdbRating || 0;
        return ratingB - ratingA;
      };
    }
    case "DateReleasedPastToFuture": {
      return (movieA: Movie, movieB: Movie) => {
        return movieA.release.date > movieB.release.date ? 1 : -1;
      };
    }
    case "DateReleasedFutureToPast": {
      return (movieA: Movie, movieB: Movie) => {
        return movieA.release.date > movieB.release.date ? -1 : 1;
      };
    }
    case "IMDBScoreLowToHigh": {
      return (movieA: Movie, movieB: Movie) => {
        const ratingA = movieA.imdbAPIRating.imdbRating || 0;
        const ratingB = movieB.imdbAPIRating.imdbRating || 0;
        return ratingA - ratingB;
      };
    }
    case "ShudderUserRatingHighToLow": {
      return (
        { userRating: { rating: ratingA } }: Movie,
        { userRating: { rating: ratingB } }: Movie
      ) => ratingB - ratingA;
    }
    case "ShudderUserRatingLowToHigh": {
      return (
        { userRating: { rating: ratingA } }: Movie,
        { userRating: { rating: ratingB } }: Movie
      ) => ratingA - ratingB;
    }
  }
};
